module.exports = __webpack_public_path__ + "img/slider-image-01-insanon.2a1106f6.png";